import React from "react";
import Grid from "@mui/material/Grid2";
import ProjectsTable from "./ProjectsTable";
import { Breadcrumbs } from "@mui/material";

function Projects() {
  return (
    <>
      <Grid size={12}>
        <Breadcrumbs />
        <ProjectsTable />
      </Grid>
    </>
  );
}

export default Projects;
